import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { required } from '../Common/Validation';
import PropTypes from 'prop-types';
import cssclasses from './Comments.css';

const renderNameField = ({ input, type, placeholder, maxLength, meta: { touched, error } }) => {
    const invalid = touched && error;
    if (!invalid) {
        return <span className={cssclasses.field_item}><input {...input} placeholder={placeholder} maxLength={maxLength} type={type} /></span>
    } else {
        return <span className={cssclasses.field_item}>
            <input {...input} placeholder={placeholder} type={type} className={cssclasses.invalid_input} maxLength={maxLength} />
            <span className={cssclasses.validation_label}>{error}</span>
        </span>
    }
};

const renderCommentField = ({ input, type, placeholder, maxLength, meta: { touched, error } }) => {
    const invalid = touched && error;
    if (!invalid) {
        return <span className={cssclasses.field_item}><textarea {...input} name="comment" placeholder={placeholder} maxLength={maxLength}></textarea></span>
    } else {
        return <span className={cssclasses.field_item}>
            <textarea {...input} name="comment" placeholder={placeholder} maxLength={maxLength} className={cssclasses.invalid_input}></textarea>
            <span className={cssclasses.validation_label}>{error}</span>
        </span>
    }
};

let CommentEdit = (props) => {

    return (
        <div className={cssclasses.form}>
            <h4 className={cssclasses.leave_comment}>Add a Comment</h4>
            <form onSubmit={props.handleSubmit} className={cssclasses.post_edit}>
                <Field
                    name="name"
                    component={renderNameField}
                    type="text"
                    validate={required}
                    placeholder="Your Name"
                    maxLength="30" />
                <Field
                    name="comment"
                    component={renderCommentField}
                    validate={required}
                    placeholder="Add your comment here"
                    maxLength="250" />
                {!props.status.posting ?
                    <button id="submit" type="submit" className={`${cssclasses.button} ${cssclasses.add}`}>Add Comment</button> :
                    <button id="posting" className={`${cssclasses.button} ${cssclasses.posting}`}><i class="fas fa-spinner fa-spin"></i>Posting Comment</button>
                }
            </form>
        </div>

    )
}

CommentEdit.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

CommentEdit = reduxForm({
    form: 'commentEdit',
    initialValues: { name: localStorage.getItem('commentName') || undefined }
})(CommentEdit)

export default CommentEdit


// WEBPACK FOOTER //
// ./src/components/Comments/CommentEdit.js